<div class="bg-white p-4 rounded-xl flex flex-col gap-4">
    <div class="bg-white rounded-xl flex flex-row gap-4 justify-center items-center">
        <input pInputText type="text" placeholder="Dashboard Name" [(ngModel)]="dashboard().name" class="w-full">
        <button pButton type="button" label="Icon" (click)="showIconDialog.set(true)"></button>
        <i *ngIf="selectedIcon" class="pi" [ngClass]="selectedIcon"></i>
    </div>
    <input pInputText type="text" placeholder="Dashboard Beschreibung" [(ngModel)]="dashboard().description"
        class="w-full">

</div>
<!-- Buttons -->
<div class="mt-6 flex justify-end gap-2">
    <p-button pButton label="Abbrechen" (click)="onCancel()" severity="secondary" />
    <p-button pButton label="Speichern" (click)="onSave()" />
</div>

<app-icon-picker-dialog [(visible)]="showIconDialog" (iconSelected)="iconSelected($event)"></app-icon-picker-dialog>